export const TEST_ID = 'selectableFlightsGridRow';
